import React from 'react';
import { bool, func, array, object, any, string } from 'prop-types';
import { isFunction, reduce, isNil, get, isEmpty, filter, includes } from 'lodash';
import { Form, Field } from 'formik';
import {
    FormikInput,
    Button,
    Column,
    FlexContainer,
    MobileFilterWrapper,
    If
} from '../../../common';
import UserDetailForm from '../UserDetailForm';
import { validations } from '../../../../utils/misc';
import '../../../../../assets/styles/orders-filter-form.less';
import { GRAY_DARK } from '../../../../utils/colors';

const FormWrapper = ({ isMobile, title, children }) => {
    if (!isMobile) return children;
    return (
        <MobileFilterWrapper title={title}>
            { children }
        </MobileFilterWrapper>
    );
};

FormWrapper.propTypes = {
    isMobile: bool,
    title: string,
    children: any
};

class OrdersFilterContainer extends React.Component {
    state = {
        reseting: false
    };

    fields = (aditionalProps) => {
        return [
            {
                name: 'name',
                label: 'Nombre',
                type: 'input',
                InputComponent: FormikInput,
                format: (value) => value && String(value).toLowerCase()
            },
            {
                name: 'lastName',
                label: 'Apellido',
                type: 'input',
                InputComponent: FormikInput,
                format: (value) => value && String(value).toLowerCase()
            },
            {
                name: 'email',
                label: 'Mail',
                type: 'input',
                InputComponent: FormikInput,
                format: (value) => value && String(value).toLowerCase()
            },
            {
                name: 'rut',
                label: 'RUT',
                validations: [],
                isDocumentId: true,
                maxLength: 12,
                type: 'input',
                InputComponent: FormikInput,
                format: (value) =>
                    value && [validations.document.clean(value), value]
            }
        ];
    }

    _renderSubmitBtn = ({ loading, dirty, touched, isMobile }) => {
        return (
            <FlexContainer>
                <Column>
                    <Button text='Limpiar' link type='reset' />
                </Column>
                <Column>
                    <Button
                        type='submit'
                        primary={dirty || touched}
                        loading={loading}
                        text='Buscar'
                        left='5'
                    />
                </Column>
            </FlexContainer>
        );
    };

    _renderForm = ({
        handleSubmit,
        handleReset,
        handleChange,
        values,
        submitCount,
        dirty,
        touched,
        isSubmitting,
        loading,
        setFieldValue
    }) => {
        const { onlyShoppers, isMobile, title } = this.props;
        const fields = onlyShoppers ? filter(this.fields(), ({ name }) => !includes(['groups'], name)) : this.fields();
        const formStyles = isMobile ? {
            flexDirection: 'column'
        } : {
            display: 'flex',
            borderRadius: '4px',
            border: `1px solid ${GRAY_DARK}`
        };
        return (
            <div style={{ width: '100%' }}>
                <FormWrapper isMobile={isMobile} title={title}>
                    <If
                        condition={!this.state.reseting}
                        then={
                            <Form
                                className='filter-form'
                                onSubmit={handleSubmit}
                                onReset={handleReset}
                                style={{
                                    alignItems: 'center',
                                    padding: '24px',
                                    ...formStyles
                                }}
                            >
                                { fields.map(({ label, name, InputComponent, onChange, ...props }, index) => (
                                    <Field
                                        style={{ marginRight: 24 }}
                                        name={name}
                                        key={`filter-form-${index}`}
                                        label={label}
                                        {...props}
                                        component={InputComponent}
                                        setFieldValue={setFieldValue}
                                    />
                                ))}
                                {this._renderSubmitBtn({ loading, dirty, touched, isMobile })}
                            </Form>
                        }
                    />
                </FormWrapper>
            </div>
        );
    };

    handleSubmit = async (values) => {
        const { onSubmit } = this.props;
        const filters = Object.keys(values).map((field) => {
                const { format } = this.fields().find(({ name }) => field === name) || {};
                const value = {
                    field,
                    type: typeof get(values, `${field}.value`, get(values, field)),
                    value: isFunction(format) ? format(values[field]) : values[field]
                };
                return value;
            })
            .filter(({ value }) => !isNil(value) && !isEmpty(value));

        onSubmit({ filters });
    };

    onReset = async (values) => {
        const { onReset } = this.props;
        this.setState({ reseting: true });
        setTimeout(() => {
            this.setState({ reseting: false });
        }, 50);
        onReset({ filters: {} });
    };

    render () {
        const { collapsed, onClick } = this.props;
        const initialValues = reduce(
            this.fields,
            (acc, { name, defaultValue = '' }) =>
                Object.assign({}, acc, { [name]: defaultValue }),
            {}
        );
        return (
            <FlexContainer pB={15}>
                <If
                    condition={!collapsed}
                    then={
                        <UserDetailForm
                            initialValues={initialValues}
                            onSubmit={this.handleSubmit}
                            onReset={this.onReset}
                            FormComponent={(props) => this._renderForm(props)}
                        />
                    }
                />
            </FlexContainer>
        );
    }
}

OrdersFilterContainer.propTypes = {
    collapsed: bool,
    initialValues: object,
    onClick: func,
    onSubmit: func,
    onReset: func,
    onlyShoppers: bool,
    abmOperUserAllowed: array,
    isMobile: bool,
    title: string
};

OrdersFilterContainer.defaultProps = {
    initialValues: {},
    isMobile: false,
    title: ''
};

export default OrdersFilterContainer;
